import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import {catchError, retryWhen, delay, tap, delayWhen, map} from 'rxjs/operators';
import { Observable, of, timer } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MonitoringService } from '../utility/monitoring/monitoring.service';
import md5 from 'crypto-js/md5';
import enc from 'crypto-js/enc-base64';
import { genericRetryStrategy } from '../rxjs-utils';
import {select, Store} from '@ngrx/store';
import {IAppState} from '../../store/state/app.state';
import {UrlControllerService} from '../url-controller.service';
import {IChannel} from '../../models/channels.interface';
import {result} from 'lodash';
import {INext} from '../../models/next.interface';

@Injectable({
  providedIn: 'root',
})
export class VideoService extends UrlControllerService {

  private _videoUrl = '';

  public get videoUrl(): string {
    return this._videoUrl;
  }
  public set videoUrl(value: string) {
    this._videoUrl = value;
  }

  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private monitoringService: MonitoringService,
    public _store: Store<IAppState>
  ) {
    super(_store);
  }

  getVideoUrl(obj: any) {
    this.http
      .get(`${this.apiUrlSelected}rest/video/token/${obj.cid}/${obj.ip}/${obj.meeting}`)
      .pipe(
        // retry(3), // retry a failed request up to 3 times
        catchError(this.monitoringService.handleError('getUrl', null)) // then handle the error
      )
      .subscribe((data: any) => {
        if (data && data.url) {
          this._videoUrl = data.url;
        } else {
          const errore = {
            code: 0,
            description: 'No data',
          };
          this.promptUser(errore);
        }
      });
  }

  getVideoUrlObs(obj: any): Observable<any> {
    return this.http
      .get(`${this.apiUrlSelected}rest/video/token/${obj.cid}/${obj.sid}/${obj.ip}/${obj.meeting}`)
      .pipe(
        // retry(3), // retry a failed request up to 3 times
        retryWhen(genericRetryStrategy()),
        catchError(
          this.monitoringService.handleError<any>('geturl', {
            url: 'https://content.jwplatform.com/manifests/yp34SRmf.m3u8',
          })
        ) // then handle the error
      );
  }

  getVideoToken(ip: string, url: string): string {
    const milliseconds = String(Math.round(new Date().getTime() / 1000) - 2);
    const string = 'De4Gnh9e' + url + milliseconds + ip;
    const hash = md5(string).toString(enc);
    return 'https://s83813.cdn.ngenix.net' + url + 'manifest.m3u8?t=' + milliseconds + '&h=' + hash;
  }

  private promptUser(data): void {
    let message = `${data.description}`;

    if (data.code === 1024) {
      message = `${data.description}`;
    }

    const snackBarRef = this.snackBar.open(
      message,
      'OK',

      {
        horizontalPosition: 'right',
        verticalPosition: 'top',
      }
    );
    snackBarRef.onAction().subscribe();
  }


  getVideoChannels(): Observable<IChannel[]> {
    return this.http.get<any>(this.apiUrlSelected + 'rest/program/channels').pipe(
        map((x) => {
          return x !== null ? x : {channel: []};
        }),
        catchError(
            this.monitoringService.handleError<IChannel>('getChannel', { channel: [] })
        )
    );
  }

}
